import { gspx } from '@rsos/gainsight';

export const trackPushNotificationEnabled = (irpVersion: string) => {
  gspx.trackCustomEvent('Push Notification', {
    irpVersion,
    name: `User granted push notification`,
    Category: 'Push Notification',
    'Launched date': new Date(),
  });
};
export const trackPushNotificationDenied = (irpVersion: string) => {
  gspx.trackCustomEvent('Push Notification', {
    irpVersion,
    name: `User denied push notification`,
    Category: 'Push Notification',
    'Launched date': new Date(),
  });
};
